import type { EditorView } from '@tiptap/pm/view';
import type { Editor } from '@tiptap/react';
import {
  isCustomNodeSelected,
  isEditorDomConnected,
  isTextSelected,
  safeDomAtPos,
  shouldShowTableMenu,
} from '../core';

export type BubbleMenuShouldShowArgs = { view: EditorView; from?: number };

/**
 * BubbleMenu `shouldShow` for the floating text toolbar: safe DOM resolution +
 * custom-node guard + table-menu handover + text selection check. Shared by
 * v1 / vMarkdown / vJSON / markdown-native editors.
 */
export function bubbleMenuTextShouldShow(
  editor: Editor,
  selector: string,
  { view, from }: BubbleMenuShouldShowArgs
): boolean {
  if (!isEditorDomConnected(editor)) {
    return false;
  }

  const dragHandleMenu = document.getElementById(selector);
  if (!view || editor.view.dragging || dragHandleMenu) {
    return false;
  }

  // One floating menu at a time — `shouldShowTableMenu` owns the rule.
  if (shouldShowTableMenu(editor)) {
    return false;
  }

  try {
    const pos = from ?? 0;
    const domResult = safeDomAtPos(view, pos);
    if (!domResult) {
      return false;
    }

    const domAtPosEl = domResult.node as HTMLElement;
    const nodeDOM = view.nodeDOM(pos) as HTMLElement | null;
    const node = nodeDOM || domAtPosEl;

    if (isCustomNodeSelected(editor, node)) {
      return false;
    }

    return isTextSelected({ editor });
  } catch {
    return false;
  }
}
